export const validationIsEqual = (act1, act2) => act1 && act2
    && act1.type === act2.type
    && act1.error === act2.error;

export const validationActionTypeisEqual=(action1, action2)=>action1&&action2
&& action1.type===action2.type
&& action1.error===action2.error
&& action1.value.fieldType===action2.value.fieldType
